import styled from "styled-components";

export const Wrap = styled.section`
  align-items: center;

  /* background-color: ${({ theme }) =>
    theme.discountMessage.backgroundColor}; */
  background-color: var(--p-color-static-orange-background);
  border-radius: ${({ theme }) => theme.borderRadius.smallRounding};
  color: ${({ theme }) => theme.discountMessage.textColor};
  display: flex;
  flex-direction: row;
  font-size: 16px;
  justify-content: space-between;
  line-height: 24px;
  margin-top: 10px;
  padding: 16px;
  width: 100%;

  @media screen and (max-width: 482px) {
    flex-wrap: wrap;
  }
`;

export const DiscountText = styled.div`
  align-items: center;
  display: flex;
  margin-right: 10px;

  & svg {
    margin-right: 10px;
    margin-top: 6px;
  }
`;

export const TotalPriceText = styled.div`
  @media screen and (max-width: 482px) {
    display: flex;
    margin-top: 8px;
  }
`;

export const DiscountWrap = styled.div`
  display: flex;
  flex-flow: row wrap;
`;

export const StyledTotalPrice = styled.div`
  @media screen and (max-width: 482px) {
    margin: 0 3px;
  }

  & p {
    &:nth-child(2) {
      font-weight: 600;
    }

    margin-bottom: 0;
  }
`;

export const StyledDiscount = styled.div`
  margin: -1px 3px 0;

  @media screen and (max-width: 482px) {
    margin: 0 3px;
  }

  & p {
    display: inline;

    &:nth-child(2) {
      font-weight: 600;
    }
  }
`;
